import { type AnyProps } from '@post-office/placement-common-v2/create-placement/types';
import { createWithI18n } from '@post-office/placement-common-v2/i18n';
import { messagesLoader as growth} from '@post-office/team-package--i18n--growth';
import { type ComponentType } from 'react';

export const withI18n: <T extends AnyProps>(component: ComponentType<T>) => ComponentType<T> = createWithI18n(growth);